import { Box, Icon, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import SmallBadge from '@sophocles/components/SmallBadge';

/**
 * Row of ticket-related links shown above the power/solar report views.
 *
 * "New Ticket" (staff only) and "Support Tickets" links, scoped to the
 * current customer/plant/structure route params.
 *
 * @param {Object} props
 * @param {{ cust_id: string, sitegroup_id: string, site_id: string }} props.params  route params
 * @param {boolean} props.isStaff  whether to show the "New Ticket" link
 */
export default function TicketLinksHeader({ params, isStaff }) {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
      <Link to={`/c/${params.cust_id}/plant/${params.sitegroup_id}/structure/${params.site_id}/ticket/new`}>
        {isStaff ? (
          <SmallBadge
            overlap="circular"
            badgeContent="+"
            color="primary"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <IconButton
              tooltip={t('general.newTicket', 'New Ticket')}
              tooltipposition="bottom-center"
              iconstyle={{ color: 'var(--text-secondary)' }}
            >
              <Icon fontSize="small" className="fas fa-ticket-alt" />
            </IconButton>
          </SmallBadge>
        ) : null}
      </Link>
      <Link to={`/c/${params.cust_id}/plant/${params.sitegroup_id}/structure/${params.site_id}/tickets`}>
        <IconButton
          tooltip={t('general.supportTickets', 'Support Tickets')}
          tooltipposition="bottom-center"
          iconstyle={{ color: 'var(--text-secondary)' }}
        >
          <Icon fontSize="small" className="fas fa-ticket-alt" />
        </IconButton>
      </Link>
    </Box>
  );
}
